// eslint-disable-next-line no-restricted-imports -- the customized @/components/Table is a MantineReactTable data-grid wrapper; markdown table rendering needs the low-level Mantine Table primitives (Table.Thead, Table.Tbody, etc.)
import { Box, Stack, Table, Text } from '@mantine/core'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

import type { HelpEntry } from '@/configs/helpContent.types'

type HelpEntryAnswerProps = {
  entry: HelpEntry
}

export function HelpEntryAnswer({ entry }: HelpEntryAnswerProps) {
  return (
    <Stack px="xl">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          p: ({ children }) => <Text mb="xs">{children}</Text>,
          ol: ({ children }) => (
            <Box component="ol" mt={0} mb="xs">
              {children}
            </Box>
          ),
          ul: ({ children }) => (
            <Box component="ul" mt={0} mb="xs">
              {children}
            </Box>
          ),
          table: ({ children }) => (
            <Table withTableBorder withColumnBorders striped my="xs">
              {children}
            </Table>
          ),
          thead: ({ children }) => <Table.Thead>{children}</Table.Thead>,
          tbody: ({ children }) => <Table.Tbody>{children}</Table.Tbody>,
          tr: ({ children }) => <Table.Tr>{children}</Table.Tr>,
          th: ({ children }) => <Table.Th>{children}</Table.Th>,
          td: ({ children }) => <Table.Td>{children}</Table.Td>,
        }}>
        {entry.answer}
      </ReactMarkdown>
    </Stack>
  )
}
